/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.StandingAppointments {
    "use strict";

    export class StandingAppointmentsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        restServer: any;
        appointmentBookModalService: Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService;
        $q: angular.IQService;
        searchContextCriteria: any;
        $http: any;
        $rootScope: angular.IRootScopeService;
        mainSection: MainSection;
        manageAppointmentsSection: AppointmentsSection;
        securityChecker: Meevo.Components.Common.ISecurityService;
        dateTimesBlockingEdit: Date[] = [];

        get isBlockedFromEditing() {
            return this.dateTimesBlockingEdit && this.dateTimesBlockingEdit.length > 0;
        }

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            restServer: any,
            appointmentBookModalService: Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService,
            $q: angular.IQService,
            searchContextCriteria: any,
            $http: any,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            $rootScope: angular.IRootScopeService,
            private stepOverrideService,
            private $filter: angular.IFilterService,
            private appointmentEditorService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);
            //NOTE:these need to be declared before the call to super (and not set as private in the constructor) because
            // tsc will put the assignment after the call to super, but initializeSections needs to refer to restServer.
            this.restServer = restServer;
            this.appointmentBookModalService = appointmentBookModalService;
            this.$q = $q;
            this.searchContextCriteria = searchContextCriteria;
            this.$http = $http;
            this.$rootScope = $rootScope;
            this.baseEndpoint = appSettings.API_ENDPOINTS.appointmentSchedule;
            this.sectionTemplatePath = "app/plugins/standingAppointments/sectionViews/";
            this.buildCrudSecurityKeys(this.securityKeys.APPOINTMENTS_STANDINGDEFINITION_TAB_MAIN);
            this.entityType = 'StandingDefinition';
            this.securityChecker = securityChecker;
            this.initializeSections();
        }

        initializeSections(): void {
            this.mainSection = new MainSection(
                0,
                "SECTION_SERVICES_MAIN",
                "main.html",
                true,
                false,
                this.appSettings.API_ENDPOINTS.appointmentSchedule,
                "",
                this.loggingService,
                this.dataService,
                this.restServer,
                this.modalService,
                this.searchContextCriteria,
                this.$http,
                this.appSettings,
                this.appointmentBookModalService,
                this.$translate,
                this.$timeout,
                null,
                Meevo.Model.NounEnum.StandingDefinitionMain,
                this.securityChecker,
                this.securityKeys.APPOINTMENTS_STANDINGDEFINITION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                this.stepOverrideService,
                this.$q,
                this
            );

            this.manageAppointmentsSection = new AppointmentsSection(
                1,
                "LABEL_MANAGE_APPOINTMENTS",
                "appointments.html",
                false,
                true,
                "",
                "",
                this.loggingService,
                this.dataService,
                this.identityService,
                this.$q,
                this.$translate,
                this.$rootScope,
                this.modalService,
                this.$filter,
                Meevo.Model.NounEnum.StandingDefinitionManageAppointments,
                this.appointmentEditorService
            );

            this.sections.push(
                this.mainSection,
                this.manageAppointmentsSection
            );
        }

        initializeHeader(model: any): void {
            this.headerContent = model.client.displayName;
        }

        get showUndelete(): boolean {
            return false;
        }

        handleWarningsConfirm(warnings: any[], customHeaderMessage: string): ng.IPromise<boolean> {
            var deferred = this.$q.defer<boolean>();
            var warningsAreDatesBlockingEdit = warnings.length > 0 && warnings[0].message && moment(warnings[0].message).isValid();
            var header = customHeaderMessage || "HEADER_APPOINTMENT_WARNING";
            var buttonsType = Meevo.Model.ButtonTypeEnum.YesNo;
            
            if (warningsAreDatesBlockingEdit) {
                var section = (this.selectedSection as MainSection);
                if (!section) {
                    deferred.resolve(false);
                    return deferred.promise;
                }
                
                this.selectedSection.rollbackChanges();
                this.dateTimesBlockingEdit = warnings.map(warning => moment(warning.message).toDate());
                section.model.isReadOnly = this.isBlockedFromEditing;

                warnings = this.formatDateTimesBlockingEdit(this.dateTimesBlockingEdit);
                buttonsType = Meevo.Model.ButtonTypeEnum.Ok;
            }

            this.appointmentBookModalService.showMessages(warnings, header, {
                buttonsType: buttonsType,
                callback: (messageResult) => {
                    deferred.resolve(!warningsAreDatesBlockingEdit &&
                        messageResult === Meevo.Model.MessageBoxButtonResult.Yes);
                }
            }, !warningsAreDatesBlockingEdit);

            return deferred.promise;
        }

        postAdd(model: any) {
            if (model.hasConflicts) {
                this.modalService.alert("MESSAGE_STANDING_DEFINITION_BOOKING_CONFLICT").then(() => {
                    this.selectSection(this.manageAppointmentsSection);
                });
            } else {
                super.postAdd(model);
            }
            if (this.selectedSection.sectionId === 0) {
                let preSaveModel = <Meevo.Model.AppointmentSchedule>this.selectedSection.preSaveModel;
                preSaveModel.services.forEach(service =>
                {
                    this.stepOverrideService.save(service, preSaveModel.client, this.selectedSection.model.id, Model.NounEnum.StandingDefinition);
                });
            }
        }
        postUpdate(model: any) {
            this.headerContent = model.serviceDisplayName;
            if (model.hasConflicts) {
                this.modalService.alert("MESSAGE_STANDING_DEFINITION_BOOKING_CONFLICT").then(() => {
                    return this.selectSection(this.manageAppointmentsSection);
                });
            } else {
                super.postUpdate(model);
            }
            if (this.selectedSection.sectionId === 0) {
                let preSaveModel = <Meevo.Model.AppointmentSchedule>this.selectedSection.preSaveModel;
                preSaveModel.services.forEach(service => {
                    this.stepOverrideService.save(service, preSaveModel.client, this.selectedSection.model.id, Model.NounEnum.StandingDefinition);
                });
            }
        }

        postCancel() {
            if (Model.Guard.isSomething(this.selectedSection.model)) {
                this.selectedSection.sectionModelRetrieved();
            }
            super.postCancel();
        }

        private deleteAppointmentSchedule(endpoint: string) {
            let vm = this;

            vm.loadingInProgress = true;

            // Patch model object state to deleted
            vm.dataService.objectStatePatch(
                vm.baseEndpoint,
                vm.itemId,
                vm.selectedSection.model.entityVersion,
                <number>Model.ObjectStateEnum.Deleted,
                vm.asLocationId,
                endpoint
            ).then((data) => {
                if (data) {
                    vm.selectedSection.model = data;
                    vm.selectedSection.sectionModelRetrieved();
                    vm.loggingService.trace('Delete saved.');
                }
                this.postDelete();
            })
                .finally(() => {
                    vm.loadingInProgress = false;
                });
        }

        /**
         * Deletes the selected item.
         */
        delete(): void {
            let vm = this;

            if (this.canDelete) {
                this.modalService.warning(this.deleteConfirmationMessageKey, 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then(() => {
                    let endpoint = '';

                    this.dataService.customMethodData(`/api/appointmentSchedule/${vm.itemId}/existsToday`, 'GET', null).then((result: any) => {
                        let appointmentExistsToday = result.data;
                        if (appointmentExistsToday) {
                            this.modalService.confirmHandler("MESSAGE_STANDING_DEFINITION_APPOINTMENT_DELETE_TODAY").then((response: boolean) => {
                                if (response) {
                                    endpoint = 'deleteToday';
                                }
                                this.deleteAppointmentSchedule(endpoint);
                            });
                        } else {
                            this.deleteAppointmentSchedule(endpoint);
                        }
                    });

                });
            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }

            this.usageTrackingLog(Meevo.Model.VerbEnum.DeleteButtonClicked, null);
        }

        formatDateTimesBlockingEdit(dates): AppointmentBook.Services.ModalMessage[] {
            const dateFilter = <any>this.$filter('meevoDateFilter');
            const timeFilter = <any>this.$filter('meevoTimeFilter');
            return dates.map(dateTime => {
                return {
                    message: `${dateFilter(dateTime)} ${timeFilter(dateTime)}`
                }
            });
        }

        edit(): void {
            this.dataService.customMethodData(`api/AppointmentSchedule/${this.itemId}/UpdatedServices/List`, 'GET', null).then(res => {
                this.dateTimesBlockingEdit = res.data;
                (this.selectedSection as MainSection).model.isReadOnly = this.isBlockedFromEditing;

                if (!this.isBlockedFromEditing) {
                    super.edit();
                    return;
                }

                let header = 'MESSAGE_STANDING_APPOINTMENT_ONLY_ADJUST_DO_NOT_CONFIRM';

                var messages = this.formatDateTimesBlockingEdit(this.dateTimesBlockingEdit);
                this.appointmentBookModalService
                    .showMessages(messages, header, { buttonsType: Model.ButtonTypeEnum.Ok }, false)
                    .then(() => super.edit());
            });
        }

        save(): angular.IPromise<any> {
            if (this.selectedSection instanceof MainSection && this.isEditing && !this.isBlockedFromEditing) {
                return this.selectedSection.showSaveWarning().then((res) => {
                    if (this.selectedSection.model.suppressWarnings) {
                        this.$timeout(() => this.loadingInProgress = true);
                    }
                    if (res) {
                        super.save();
                    }
                });
            }

            return super.save();
        }

        postDelete(): void {
            this.usageTrackingLog(Meevo.Model.VerbEnum.Deleted, null);
        }

        setModelDateUpdated(dateUpdated: Date): void {
            this.manageAppointmentsSection.scheduleDateUpdated = dateUpdated;
        }
    }
}